export default "__VITE_ASSET__B9RC8cQD__"